import { Router } from '@angular/router';
import { AppNotification } from '../models/notification.models';

const KNOWN_URL_PREFIXES = ['/mis-reservas/', '/notificaciones'];

export function navigateToNotificationTarget(router: Router, notification: AppNotification): void {
  const { reservation_id, url } = notification.data;

  if (reservation_id) {
    router.navigate(['/mis-reservas', reservation_id]);
    return;
  }

  if (url && KNOWN_URL_PREFIXES.some((prefix) => url.startsWith(prefix))) {
    router.navigateByUrl(url);
  }
}
